module.exports = __webpack_public_path__ + "static/media/new_c.9eec15d8.svg";